import CloseIcon from '@mui/icons-material/Close';
import { Dialog, styled, Typography, Box as MuiBox } from '@mui/material';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.primary.main,
    border: `1px solid ${theme.palette.common.white}`,
    borderRadius: '0.375rem',
    width: '100%',
    maxWidth: '37.5rem',
    padding: '1.5rem',
    gap: '2rem',
    flexGrow: 1,
    maxHeight: '90vh',
    [theme.breakpoints.down('sm')]: {
      borderRadius: 0,
      height: '100%',
      maxHeight: '100%',
      width: '100%',
      padding: '1.5rem',
    },
  },
}));

export const Content = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1.5rem',
  flexGrow: 1,
  overflow: 'hidden',
  minHeight: 0,
}));

export const Box = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '0.5rem',
}));

export const CloseBox = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
}));

export const CloseIconStyled = styled(CloseIcon)(({ theme }) => ({
  cursor: 'pointer',
  color: theme.palette.common.white,
  '&:hover': {
    color: theme.palette.grey[600],
  },
}));


export const Footer = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
}));

export const LeftContentWrapper = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  color: theme.palette.common.white,
}));

export const ScrollableCardsWrapper = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  padding: '1rem 0',
  overflowY: 'auto',
  overflowX: 'hidden',
  [theme.breakpoints.up('sm')]: {
    minHeight: '12rem',
    maxHeight: '20rem',
  },
  [theme.breakpoints.down('sm')]: {
    flexGrow: 1,
    maxHeight: 'none',
    minHeight: 0,
  },
}));